// Component here uses ES6 destructuring syntax in import, what is means is "retrieve the property 'Component' off of the object exported from the 'react'"
import React, { Component, PropTypes, Children, cloneElement } from 'react';

// import classnames utility
import cx from 'classnames';

// js utility functions
import _ from 'lodash';

// import modified component from material UI
import MenuItem from '../c_SourceModMenuItem';

// import material UI element with slightly modified source code
import DropDownMenu from 'material-ui/DropDownMenu';

import {validateField} from '../../../modelValidator';

const dropdownStyle = {
  // overflow: 'hidden'
};

const menuCustomization = {
  autoWidth: false,
  menuStyle: {
    overflowX: 'hidden',
    width: '100%',
    backgroundColor: '#fafafa'
  },
  labelStyle: {
    color: 'rgb(33, 35, 38)',
    maxWidth: '100%',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    fontSize: '16px',
    height: '48px'
  },
  listStyle: {
    backgroundColor: '#fafafa',
    fontWeight: 400,
    width: '100%',
    color: 'red'
  },
  floatingLabelText:{
    color: 'rgb(33, 35, 38)'
  },
  selectedMenuItemStyle: {
    padding: 0,
    color: 'rgb(33,35,38)',
    backgroundColor: '#eee'
  },
  popoverStyle: {
    transition: 'transform 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms, opacity 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms, top 450ms cubic-bezier(0.23, 1, 0.32, 1), width 1000ms cubic-bezier(0.23, 1, 0.32, 1)'
  }
};

const menuItemCustomization = {
  disableTouchRipple: true,
  disableFocusRipple: true
};


export default class CustomDropDownMenu extends Component {
  static propTypes = {
    defaultValue: PropTypes.any,
    value: PropTypes.any,
    id: PropTypes.any,
    disabled: PropTypes.bool,
    validation: PropTypes.object,
    onErrorChange: PropTypes.func,
    onChange: PropTypes.func,
    onBlur: PropTypes.func,
    menuItems: PropTypes.array.isRequired,
    className: PropTypes.string,
    style: PropTypes.object,
    listStyle: PropTypes.object,
    menuStyle: PropTypes.object,
    containerStyle: PropTypes.object,
    errorText: PropTypes.string,
    floatingLabelText: PropTypes.string,
    floatingLabelStyle: PropTypes.object,
    labelStyle: PropTypes.object,
    iconStyle: PropTypes.object,
    menuItemCustomization: PropTypes.object,
    selectedMenuItemStyle: PropTypes.object,
    'data-id': PropTypes.string,
    children: PropTypes.object,
    isSubElement: PropTypes.bool,
    canAutoPosition: PropTypes.bool,
    includeDefault: PropTypes.bool,
    subElement: PropTypes.string,
    primaryText: PropTypes.string,
    name: PropTypes.string,
    underlineStyle: PropTypes.object,
    isDirty: PropTypes.bool,
  }

  static defaultProps = {
    menuItems: []
  }

  state = {
    value: null,
    errors: [],
    dirty: false,
    primaryText: this.props.primaryText || this.props.name || 'Select',
    subElement: null
  }

  componentWillMount() {
    const initVal = this.props.hasOwnProperty('value') ? this.props.value : this.props.hasOwnProperty('defaultValue') ? this.props.defaultValue : null;

    // used to keep track of mounting state updates
    const stateUpdateObj = {};

    if(!_.isNil(initVal)) {
      stateUpdateObj.value = initVal;
      const currentMenuItem = this.props.menuItems.find(menuItem => menuItem.value === initVal || menuItem.id === initVal || menuItem === initVal);
      if(!currentMenuItem) {
        console.error(`value: ${initVal} does not have corresponding menu item`); /* eslint no-console:0 */
      } else if(currentMenuItem.subElement) {
        stateUpdateObj.subElement = currentMenuItem.subElement;
      }
    }

    // handles validation state update
    this.validate(initVal, stateUpdateObj);
  }

  componentWillReceiveProps(nextProps) {
    // sync local state value
    if(this.props.value !== nextProps.value) {
      this.validate(nextProps.value, {
        value: nextProps.value
      });
    }
  }

  componentWillUnmount() {
    if(this.state.errors.length && this.props.onErrorChange) {
      this.props.onErrorChange(-1);
    }
  }

  onChange(event, index, value) {
    // handle edge case of user re-selecting select
    const selectWasSelected = value === null;

    // need to take select into account (if they just selected something else but were on select)
    const selectPreviouslySelected = _.isNil(this.state.value);
    const adjIndex = selectPreviouslySelected ? index - 1 : index;

    // send primaryText and subElement values to callback too
    const menuItem = this.props.menuItems[adjIndex] || {};
    const primaryText = selectWasSelected ? null : menuItem.primaryText || menuItem.name || value;
    const subElement = selectWasSelected ? null : menuItem.subElement;

    const adjValue = value === 'Yes' ? true : value === 'No' ? false : value;

    function invokeCallbacks() {
      if(this.props.onChange) {
        this.props.onChange(event, adjValue, primaryText, subElement);
      }
      if(this.props.onBlur) {
        this.props.onBlur(event, adjValue, primaryText, subElement);
      }
    }

    // update local state, invoke callbacks AFTER state is updated
    if(!this.props.hasOwnProperty('value')) {
      this.validate(value, {
        value,
        subElement
      });
      invokeCallbacks.bind(this)();
    } else {
      this.setState(_.assign({}, this.state, {
        value,
        subElement
      }), invokeCallbacks);
    }


  }

  checkErrors() {
    if(!this.state.dirty) {
      this.setState({dirty: true}); // set dirty if not already dirty
    }
  }

  validate = (value, mergeObj) => {
    if(this.props.validation) {
      const errorsObj = {
        errors: validateField(value, this.props.validation)
      };
      if(errorsObj.errors.length !== this.state.errors.length) {
        if(this.props.onErrorChange) {
          this.props.onErrorChange(errorsObj.errors.length > this.state.errors ? 1 : -1);
        }
        this.setState(_.assign({}, this.state, errorsObj, mergeObj || {}));
      } else if (_.size(mergeObj)) {
        this.setState(_.assign({}, this.state, mergeObj));
      }
    } else if (_.size(mergeObj)) {
      this.setState(_.assign({}, this.state, mergeObj));
    }
  }

  render() {
    // take out properties that will be overwritten from 'this.props'
    const canAutoPosition = this.props.canAutoPosition === undefined ? true : this.props.canAutoPosition;
    const {
      className,
      value,        /* eslint no-unused-vars:0 */
      defaultValue, /* eslint no-unused-vars:0 */
      onChange,     /* eslint no-unused-vars:0 */
      onBlur,       /* eslint no-unused-vars:0 */
      style,
      'data-id': dataId,
      floatingLabelText,
      floatingLabelStyle,
      containerStyle,
      includeDefault,
      menuItemCustomization: propsMenuItemCustomization,
      selectedMenuItemStyle: propsSelectedMenuItemStyle,
      listStyle: propsListStyle,
      menuStyle: propsMenuStyle,
      labelStyle: propsLabelStyle,
      iconStyle: propsIconStyle,
      ...unmodifiedProps
    } = this.props;

    const additionalProps = {
      onChange: ::this.onChange,
      style: _.merge({}, style, dropdownStyle)
    };

    if(_.isNil(this.state.value)) {
      additionalProps.value = null;
    } else {
      additionalProps.value = typeof this.state.value !== 'object' ? this.state.value :
        this.state.value.hasOwnProperty('value') ? this.state.value.value :
        this.state.value.hasOwnProperty('id') ? this.state.value.id : null;
    }

    // list style
    if(propsListStyle) {
      additionalProps.listStyle = _.merge({}, menuCustomization.listStyle, propsListStyle);
    }

    // menu style
    if(propsMenuStyle) {
      additionalProps.listStyle = _.merge({}, menuCustomization.menuStyle, propsMenuStyle);
    }

    if(propsSelectedMenuItemStyle) {
      additionalProps.selectedMenuItemStyle = _.merge({}, menuCustomization.selectedMenuItemStyle, propsSelectedMenuItemStyle);
    }

    additionalProps.iconStyle  = {
      fill: '#161b21'
    };


    additionalProps.underlineStyle = {
      borderTop: 'solid 1px #161b21'
    };

    let redfloatingLabelStyle = {};
    // if dropdown value is null (displaying 'Select') make text gray
    if((this.state.dirty || this.props.isDirty) && this.state.errors.length) {
      additionalProps.labelStyle = _.merge({}, menuCustomization.labelStyle, propsLabelStyle, {
        color: 'rgb(244, 67, 54)'
      });
      additionalProps.errorText = this.state.errors.join(', ');
      redfloatingLabelStyle = {
        color: 'rgb(244, 67, 54)'
      };
      additionalProps.iconStyle  = {
        fill: 'rgb(244, 67, 54)'
      };
      additionalProps.underlineStyle = {
        borderTop: 'solid 1px rgb(244, 67, 54)',
      };
    }
    else if(additionalProps.value === null) {
      additionalProps.labelStyle = _.merge({}, menuCustomization.labelStyle, propsLabelStyle, {
        color: '#212326',
        fontWeight: 'normal'
      });
    } else if (propsLabelStyle) {
      additionalProps.labelStyle = _.merge({}, menuCustomization.labelStyle, propsLabelStyle);
      additionalProps.iconStyle = _.merge({}, menuCustomization.iconStyle, propsIconStyle);
    }

    if (this.props.iconStyle) {
      additionalProps.iconStyle = _.merge({}, additionalProps.iconStyle, this.props.iconStyle);
    }

    if (this.props.underlineStyle) {
      additionalProps.underlineStyle = _.merge({}, additionalProps.underlineStyle, this.props.underlineStyle);
    }

    const startWithSelect = !!~[null, ''].indexOf(additionalProps.value);
    if(startWithSelect) {
      additionalProps.selectedMenuItemStyle = _.merge(additionalProps.selectedMenuItemStyle, menuCustomization.selectedMenuItemStyle, propsSelectedMenuItemStyle || {}, {
        padding: 0,
        backgroundColor: '#fafafa',
        cursor: 'default'
      });
    } else if(propsSelectedMenuItemStyle) {
      additionalProps.selectedMenuItemStyle = _.merge({}, menuCustomization.selectedMenuItemStyle, propsSelectedMenuItemStyle);
    }

    return (
      <div className={cx('clearfix', 'dropdown-wrapper', className, {disabled: this.props.disabled})} style={containerStyle}>
        {
          floatingLabelText
          &&
          <div className='floatingLabelText' data-id={`${dataId} floatingLabelText`} style={floatingLabelStyle || redfloatingLabelStyle || {}}>
            {floatingLabelText}
          </div>
        }
        <DropDownMenu className='dropdown'
                      data-id={dataId}
                      canAutoPosition={canAutoPosition}
                      value={this.state.value || ''}
                      {...menuCustomization}
                      {...unmodifiedProps}
                      {...additionalProps}>

          <MenuItem value=''
            style={{display: !_.isNil(this.state.value) ? 'none': 'block'}}
            primaryText={this.props.primaryText}
            data-id={this.props.primaryText}
            {...menuItemCustomization}
            {...propsMenuItemCustomization}/>
          {
            this.props.menuItems.map((val, index) => {
              if(typeof val === 'undefined') {
                return undefined;
              }
              let value;
              let primaryText;
              let hide = false;
              if(typeof val === 'string' || typeof val === 'number') {
                value = primaryText = val;
              } else if(typeof val === 'boolean') {
                value = primaryText = val === true ? 'Yes' : 'No';
              } else {
                if(val.hasOwnProperty('value') || val.hasOwnProperty('id')) {
                  value = val.hasOwnProperty('value') ? val.value : val.id;
                }
                if(val.hasOwnProperty('primaryText') || val.hasOwnProperty('name')) {
                  primaryText = val.hasOwnProperty('primaryText') ? val.primaryText : val.name;
                }
                if(val.hasOwnProperty('hide')) {
                  hide = val.hasOwnProperty('hide') ? val.hide : false;
                }
              }

              return (
                <MenuItem value={value}
                          style={{display: hide ? 'none': 'block'}}
                          primaryText={primaryText}
                          key={index}
                          data-id={primaryText}
                          {...menuItemCustomization}
                          {...propsMenuItemCustomization}/>
              );
            })
          }
        </DropDownMenu>
        {
          this.props.children
          &&
          this.props.children[this.state.subElement]
          &&
          <div className='subElement-container'>
            {
              Children.map(this.props.children[this.state.subElement], // adding isSubElement prop to child
               child => cloneElement(child, _.merge(
                    {isSubElement: true},
                    {containerStyle: {width: '100%'}, style: {width: '100%', margin: '-1px'}},
                    {containerStyle: child.containerStyle || {}, style: child.containerStyle || {}}
                  )))
            }
          </div>
        }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./shared/common/components/SimpleDropDownMenu/index.js